import React, { FC, PropsWithChildren, useEffect } from "react";
import { useSheshaApplication } from "@shesha-io/reactjs";
import { formDesignerComponents } from "../designer-components";
import { CustomConfigurableActionsAccessor } from "../components/configurable-actions/custom-configurable-actions-processor";

export interface IPublicPortalPluginProps {}

export const TEMPLATE_PLUGIN_NAME = `Shesha.Telephony`;

export const TelephonyPlugin: FC<
  PropsWithChildren<IPublicPortalPluginProps>
> = ({ children }) => {
  const { registerFormDesignerComponents } = useSheshaApplication();

  useEffect(() => {
    registerFormDesignerComponents(
      TEMPLATE_PLUGIN_NAME,
      formDesignerComponents
    );
  }, []);

  return <CustomConfigurableActionsAccessor>{children}</CustomConfigurableActionsAccessor>;
};